import React from 'react';
import "./LoadingComponents.css";
import image from "../../../Image/loadGif.gif"

function LoadingComponents() {

    return (
        <div className="ParentLoading w-100 d-flex justify-content-center align-items-center">
            <img src={image} alt=""/>
        </div>
    );
}

export default LoadingComponents;